import './App.scss';
import AppHeader from '../appHeaderComponent/AppHeader';
import Home from '../appRouteComponents/home/Home';
import Tester from '../appRouteComponents/tester/testerDetails';
import VehicleSearch from '../appRouteComponents/responder/VehicleSearch';
import AppLogin from '../appLoginComponent/AppLogin';
import EsecLogin from '../appLoginComponent/ESECLogin';
import Spinner from '../../components/Spinner';
import { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import { Container } from 'react-bootstrap';
import { ServerInfo } from '../../../services/ServerInfo';
import { CurrentUser } from '../../../services/CurrentUser';
import { UserInfo } from '../../../interfaces/userInfo.interafce';
import { APIMErrorNoCurrentUsername } from '../../../services/APIMRequest';
import UserAuthDataProvider from "../../pages/appLoginComponent/UserAuthContext";
import VehicleInfo from '../appRouteComponents/responder/VehicleInfo';
import DocViewer from '../appRouteComponents/responder/DocViewer';

function App() {
  let [currentUser, setCurrentUser] = useState(null as UserInfo | null);
  let [loading, setLoading] = useState(() =>
    sessionStorage.getItem('oidc_form_post') ? "Processing login…" : ""
  );
  let [error, setError] = useState(null as any);
  let [appSettings, setAppSettings] = useState({ displayName: "LOADING..." } as ServerInfo);

  useEffect(() => {

    onLoad().then(() => {
      setLoading("");
    }).catch((e) => {
      setLoading("");
      const errorUser = e === APIMErrorNoCurrentUsername ? null : e;
      setError(errorUser);
    });

    async function onLoad() {

      setLoading("Loading Server Info...");

      setAppSettings(await ServerInfo.get());

      setLoading("Loading User Profile...");

      var _currentUser = null as UserInfo | null;

      try {
        _currentUser = await CurrentUser.get();
        setCurrentUser(_currentUser);
      }
      catch (e) {
        setCurrentUser({ cwopa: "" } as UserInfo | null);

        throw (e);
      }
    }
  }, []);

  function GetBaseName(): string {
    return appSettings.contextRoot;
  }

  // Helper to get default route based on user role
  const getDefaultRouteForRole = (role: string, testerId?: number) => {
    if (role === "PD-AVIRP-LawEnforcement" || role === "PD-AVIRP-Firefighting" ||
      role === "PD-AVIRP-EMT" || role === "PD-AVIRP-Towing") {
      return "/vehiclesearch";
    }
    if (role === "PD-AVIRP-WebUser" && testerId) {
      return `/tester/${testerId}`;
    }
    // Default for SuperUser and others
    return "/home";
  };

  const baseName = GetBaseName();
  if (loading) {
    return <Spinner />;
  }
  const element = (currentUser && currentUser.cwopa.length > 0) ?
    <UserAuthDataProvider esecUserRole={currentUser.role} esecTesterId={currentUser.testerId}>
      <AppHeader currentUser={currentUser} helpFile={appSettings.helpFile}></AppHeader>
      <div className="AppParent">
        <div className="AppContent">
          <Routes>
            {/* Root route redirects based on role */}
            <Route path="/" element={<Navigate to={getDefaultRouteForRole(currentUser.role, currentUser.testerId)} replace />} />

            {/* Home page only for SuperUsers */}
            <Route path="/home" element={<Home currentUser={currentUser} />} />

            {/* Other routes */}
            <Route path="/tester/:testerid/:vehicleid/:incidentid" element={<Tester />} />
            <Route path="/tester/:testerid" element={<Tester />} />
            <Route path="/vehiclesearch" element={<VehicleSearch />} />
            <Route path="/mobileView" element={<VehicleInfo />} />
            <Route path="/docViewer" element={<DocViewer />} />
          </Routes>
        </div>
      </div>
    </UserAuthDataProvider> : <EsecLogin baseName={baseName} />;
  return (
    <>
      {
        currentUser ? element : <EsecLogin baseName={baseName} />
      }
    </>
  )
}

export default App;

